import {IconButton, Tooltip} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import deleteReportFolder from 'modules/reports/api/reportFolders/deleteReportFolder'
import ReportsMenu from 'modules/reports/components/Menu'
import ReportsMenuItem from 'modules/reports/components/Menu/Item'
import useCore from 'modules/reports/hooks/core'
import useDialog from 'modules/reports/hooks/dialog'
import useModal from 'modules/reports/hooks/modal'
import ReportsUsersModal from 'modules/reports/modals/Users'
import ReportFolder from 'modules/reports/models/ReportFolder'
import React from 'react'
import useStyles from './ReportsFolderSidebarItemMenu.styles'
import {useReportsFolderSidebarContext} from 'modules/reports/components/Folder/Sidebar/ReportsFolderSidebar.context'

type Props = {
  folder: ReportFolder
}

function ReportsFolderSidebarItemMenu(props: Props) {
  const {p, pt} = useCore('reports', 'components', 'FolderSidebarItemMenu')
  const modal = useModal()
  const dialog = useDialog()
  const classes = useStyles()
  const folderSidebarContext = useReportsFolderSidebarContext()
  const {folder} = props

  function handleAddUser() {
    modal.open(ReportsUsersModal, {folder})
  }

  async function handleDeleteFolder() {
    const confirmed = await dialog.confirm(pt('confirm-delete', {name: folder.name}))
    if (!confirmed) return

    await deleteReportFolder({id: folder.id})
    folderSidebarContext.onDelete(folder)
  }

  return (
    <ReportsMenu
      trigger={({ariaProps, open}) => (
        <Tooltip title={pt('title')}>
          <IconButton
            className={classes.trigger}
            {...ariaProps}
            aria-label={pt('title')}
            onClick={open}
            data-testid={p('trigger')}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      )}
    >
      <ReportsMenuItem onClick={handleAddUser} icon={<PersonAddIcon />} data-testid={p('add-user')}>
        {pt('add-user')}
      </ReportsMenuItem>

      {folder.deleteable && (
        <ReportsMenuItem
          onClick={handleDeleteFolder}
          icon={<DeleteIcon />}
          danger
          data-testid={p('delete-folder')}
        >
          {pt('delete-folder')}
        </ReportsMenuItem>
      )}
    </ReportsMenu>
  )
}

export default ReportsFolderSidebarItemMenu
